import { Sparkles } from "lucide-react";
import { SPILL_SCENARIOS } from "../data/proposal";

const Scenario = ({ s }) => (
  <div data-testid={`spillover-scenario-${s.name}`} className="rounded-2xl bg-white/10 p-5">
    <p className="text-sm font-black text-white/80">{s.name}</p>
    <p className="mt-1 whitespace-nowrap text-2xl font-black">{s.total}</p>
    <ul className="mt-3 space-y-1 text-sm text-white/85">
      <li className="flex justify-between gap-2"><span>團建</span><span>{s.team}</span></li>
      <li className="flex justify-between gap-2"><span>訂房網站</span><span>{s.ota}</span></li>
      <li className="flex justify-between gap-2"><span>Google</span><span>{s.google}</span></li>
    </ul>
  </div>
);

export const SpilloverTotal = () => (
  <div data-testid="spillover-total" className="mt-10 rounded-3xl bg-[var(--teal-d)] p-7 text-white md:p-10">
    <p className="flex items-center gap-2 text-sm font-black tracking-widest text-white/80"><Sparkles size={16} /> 外溢效益合計（每月，與去年同期相比）</p>
    <p data-testid="spillover-total-value" className="mt-3 text-4xl font-black md:text-5xl">約 NT$82–392 萬</p>
    <p className="mt-2 text-white/85">另外再加 <b>約 432 萬次</b> UGC 曝光｜不包含「預期成果」的訂房試算</p>
    <div className="mt-6 grid gap-4 md:grid-cols-3">
      {SPILL_SCENARIOS.map((s) => <Scenario key={s.name} s={s} />)}
    </div>
    <p className="mt-4 text-xs text-white/70">金額區間 = 各房價（平日～假日）的範圍；明細見下方 A–D。</p>
  </div>
);
